import { HORIZONTAL_OFFSET, VERTICAL_GAP } from '../constants';

export const getDOMRangeRect = (
  nativeSelection: Selection,
  rootElement: HTMLElement,
): DOMRect => {
  const domRange = nativeSelection.getRangeAt(0);
  let rect;

  if (nativeSelection.anchorNode === rootElement) {
    let inner = rootElement;
    while (inner.firstElementChild != null) {
      inner = inner.firstElementChild as HTMLElement;
    }
    rect = inner.getBoundingClientRect();
  } else {
    rect = domRange.getBoundingClientRect();
  }
  return rect;
};

export const setFloatingElemPosition = ({
  targetRect,
  floatingElem,
  anchorElem,
  verticalGap = VERTICAL_GAP,
  horizontalOffset = HORIZONTAL_OFFSET,
}: {
  targetRect: DOMRect | null;
  floatingElem: HTMLElement;
  anchorElem: HTMLElement;
  verticalGap?: number;
  horizontalOffset?: number;
}) => {
  const toolbarTopOffset = 110;
  const scrollerElem = anchorElem.parentElement;

  if (targetRect === null || !scrollerElem) {
    return null;
  }

  const floatingElemRect = floatingElem.getBoundingClientRect();
  const anchorElementRect = anchorElem.getBoundingClientRect();
  const editorScrollerRect = scrollerElem.getBoundingClientRect();

  let top = targetRect.top - floatingElemRect.height - verticalGap;
  let left = targetRect.left - horizontalOffset;

  if (top < editorScrollerRect.top) {
    top += floatingElemRect.height + targetRect.height + verticalGap * 2;
  }

  if (top < toolbarTopOffset) {
    top += toolbarTopOffset;
  }

  if (left + floatingElemRect.width > editorScrollerRect.right) {
    left = editorScrollerRect.right - floatingElemRect.width - horizontalOffset;
  }

  top -= anchorElementRect.top;
  left -= anchorElementRect.left;

  return { top, left };
};
